// Reine Regeln des Vorschläge-Reiters: welche Themen in der Themen-Zeile stehen und wo in der
// Rangliste der Trenner sitzt. Eigene Datei, damit sie prüfbar bleiben, ohne den Reiter zu rendern.

/**
 * Genutzte Themen eines Deck-Profils: alle Profil-Einträge, deren `tagId` in den
 * Begründungen mindestens eines GELADENEN Vorschlags vorkommt — plus alle
 * stummgeschalteten. Ein stummes Thema erzeugt keine Begründung mehr und würde sonst aus der
 * Zeile verschwinden, sobald man es anklickt; als durchgestrichener Chip bleibt es dort
 * zurücknehmbar, hinter der Zwei-Reihen-Grenze über den Aufklapp-Chip (`splitVisibleThemes`).
 *
 * Das übrige Profil (mehrere hundert Einträge) bleibt draußen: es beschreibt das Deck,
 * sagt aber nichts über die Liste darunter — und wäre als Chip-Wand nicht bedienbar.
 * Die Reihenfolge des Profils (stärkstes Thema zuerst) bleibt erhalten.
 *
 * @param {{tagId: string, muted?: boolean}[]} profile
 * @param {{reasons?: {tagId: string}[]}[]} entries — die geladenen Vorschläge
 * @returns {object[]} Teilmenge von `profile`
 */
export function usedProfileThemes(profile, entries) {
  const genutzt = new Set();
  (entries || []).forEach((eintrag) => {
    (eintrag?.reasons || []).forEach((grund) => {
      if (grund?.tagId) genutzt.add(grund.tagId);
    });
  });
  return (profile || []).filter((thema) => thema?.muted === true || genutzt.has(thema?.tagId));
}

/**
 * Aufteilung der Themen-Zeile in sichtbare Chips und die Zahl hinter dem „+N".
 *
 * Sichtbar sind genau die ersten `limit` Themen — die Zeile darf zwei Reihen nie
 * überschreiten. Ein stummes Thema hinter der Grenze zählt in `hiddenCount` mit und erscheint
 * wie alle anderen erst nach dem Aufklappen.
 *
 * @param {{muted?: boolean}[]} themes — genutzte Themen in Profil-Reihenfolge
 * @param {number} limit — Chips vor dem „+N"
 * @returns {{visible: object[], hiddenCount: number}}
 */
export function splitVisibleThemes(themes, limit) {
  const alle = themes || [];
  if (!Number.isFinite(limit) || limit >= alle.length) return { visible: alle, hiddenCount: 0 };
  const grenze = Math.max(0, limit);
  const visible = alle.slice(0, grenze);
  return { visible, hiddenCount: alle.length - visible.length };
}

/**
 * Position des Trenners „Weitere beliebte Karten": der erste Eintrag ohne Profil-Score. Ab
 * dort stammen die Karten nicht mehr aus dem Deck-Profil, sondern aus der EDHREC-Beliebtheit —
 * der Trenner sagt das, statt die Rangliste stumm auslaufen zu lassen.
 *
 * @param {{score?: number|null}[]} entries — die Rangliste in Maschinen-Reihenfolge
 * @returns {number} Index des ersten Eintrags mit `score <= 0` (fehlender Score zählt als 0),
 *   `-1` ohne solchen
 */
export function popularDividerIndex(entries) {
  return (entries || []).findIndex((eintrag) => (eintrag.score ?? 0) <= 0);
}

export default usedProfileThemes;
